import { ImagePreprocessingRow } from 'types';

const usePreprocessings = ({
  title,
  name,
  functions,
  useFormReturn,
  loadPreviewImage,
  nodeDataSave,
}: ImagePreprocessingRow) => {
  const { watch, setValue, getValues, clearErrors } = useFormReturn;
  const preprocessings = watch(`${name}Preprocessings`);

  const handlePreviewClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    loadPreviewImage(title, preprocessings);
  };

  const handleAddClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const newFunctions = [...getValues(`${name}Preprocessings`)];
    const selectFunction = getValues(`${name}Select`)!;

    newFunctions.push({
      ...functions[selectFunction],
      parameters: functions[selectFunction].parameters.map((parameter) => {
        let value = parameter.defaultValue;

        if (value === '_Optional') {
          value = null;
        } else if (typeof value === 'boolean') {
          value = JSON.stringify(value);
          value = value.charAt(0).toUpperCase() + value.slice(1);
        }

        return {
          ...parameter,
          value,
        };
      }),
    });

    setValue(`${name}Preprocessings`, newFunctions);
    nodeDataSave();
  };

  const handleDeleteClick = (event: React.MouseEvent<HTMLButtonElement>, index: number) => {
    event.preventDefault();
    clearErrors();

    const newFunctions = [...getValues(`${name}Preprocessings`)].filter((_, i) => i !== index);
    setValue(`${name}Preprocessings`, newFunctions);
    nodeDataSave();
  };

  return {
    preprocessings,
    onAddClick: handleAddClick,
    onDeleteClick: handleDeleteClick,
    onPreviewClick: handlePreviewClick,
  };
};

export default usePreprocessings;
